"use client";

import { useEffect, useTransition } from "react";
import { getPersonalInfo } from "@/api/dashboard";
import { endSession } from "@/app/actions/auth";
import { useAuthStore } from "@/store/authStore";
import { useUserStore } from "@/store/userStore";
import { getDashboardMenuItems } from "@/constants/dashboard";

export function useHeaderAuth(redirectPath: string) {
  const [isPending, startTransition] = useTransition();
  const [isLoading, startLoadTransition] = useTransition();
  const isLoggedIn = useAuthStore((state) => state.isLoggedIn);
  const logout = useAuthStore((state) => state.logout);
  const {
    first_name: firstName,
    last_name: lastName,
    mobile: phoneNumber,
    setUser,
    resetUser,
  } = useUserStore();

  useEffect(() => {
    useAuthStore.getState().syncFromAuthPresentCookie();
  }, []);

  useEffect(() => {
    if (!isLoggedIn) {
      return;
    }

    startLoadTransition(async () => {
      try {
        const data = await getPersonalInfo();
        setUser(data);
      } catch (err) {
        console.error("Failed to load profile", err);
      }
    });
  }, [isLoggedIn, setUser]);

  const handleLogout = () => {
    startTransition(() => {
      void (async () => {
        try {
          await endSession();
        } catch (error) {
          console.error(error);
        }

        logout();
        resetUser();
        try {
          localStorage.removeItem("auth-storage");
          localStorage.removeItem("user-storage");
        } catch {
          // Ignore storage access errors.
        }

        window.location.assign(redirectPath);
      })();
    });
  };

  return {
    isLoggedIn,
    isLoading,
    firstName,
    lastName,
    phoneNumber,
    dashboardMenuItems: getDashboardMenuItems(handleLogout, isPending),
  };
}
